import { render } from "./app-loading-page.vue?vue&type=template&id=79205fce"
import script from "./app-loading-page.vue?vue&type=script&lang=js"
export * from "./app-loading-page.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/loading/app-loading-page.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "79205fce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('79205fce', __exports__)) {
    console.log('reload')
    api.reload('79205fce', __exports__)
  }
  
  module.hot.accept("./app-loading-page.vue?vue&type=template&id=79205fce", () => {
    console.log('re-render')
    api.rerender('79205fce', render)
  })

}


export default __exports__